<!-- <ul class="breadcrumb">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Payment Of Dividend</li>
</ul> -->
<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Payment of Dividend</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/paymentOfDividend/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/paymentOfDividend/edit?goveva=true&email=', 'method':'put', 'menu': 'paymentOfDividend'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <label>&nbsp;&nbsp;&nbsp;</label>
      <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
        <span>
          <i class="fa fa-save"></i>&nbsp;Generate Output </span>
      </button>
    </span>
    </div>
  
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-3">
                <label>Name of the Member(s)</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <!-- <label>Nature of Documents Inspected </label> -->
                  <input type="text" [(ngModel)]="nameOfMember" name="nameOfMember" class="form-control">
                </div>
                <br>
              </div>
  
  
              <div class="col-md-3">
                <!-- <label>Date of Declaration</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfDeclaration" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfDeclaration" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfDeclaration">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                   To:&nbsp;
                  <input id="dateOfDeclarationTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfDeclarationTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfDeclarationTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-lg-2 col-md-2 col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfPaymentOfDividend" [dtTrigger]="dtTriggerPaymentOfDividend"
                class="table table-hover compact cell-border nowrap stripe" id="paymentOfDividentTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Folio Number</th>
                    <th>Name of the Member(s) </th>
                    <th>Dividend Rate</th>
                    <th>Date of Book <br>Closure</th>
                    <th style="display: none">Date of Book Closure</th>
                    <th style="min-width:80px;">Record Date</th>
                    <th style="display: none">Record Date</th>
                    <th>Dividend Amount</th>
                    <th>Date of Payment<br> of Dividend</th>
                    <th style="display: none">Date of Payment of Dividend</th>
                    <th>Interim Dividend</th>
                    <th>Final Dividend</th>
                    <th>Date of Declaration</th>
                    <th style="display: none">Date of Declaration</th>
                    <th class="actionclass">Action</th>
                    <!-- <span [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}" class="btn-sm btn btn-warning" (click)="loadPaymentDataById(paymentOfDividendId._id)">Action</span> -->
                   
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;">
                    <td tabindex="1"> {{director.folioNo}} </td>
                    <td tabindex="1"> {{director.nameOfMembers}} </td>
                    <td tabindex="1"> {{director.dividendRate}} </td>
                    <td style="min-width:80px;" tabindex="1">
                      <span style="display: none">{{director.dateOfBookClosure | date : "yMMdd"}}</span>
                      {{director.dateOfBookClosure | date : "dd-MM-y"}} </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfBookClosure | date : "dd-MM-y"}} </td>
                    <td style="min-width:80px;" tabindex="1">
                      <span style="display: none">{{director.recordDate | date : "yMMdd"}}</span>
                      {{director.recordDate | date : "dd-MM-y"}} </td>
                    <td tabindex="1" style="display: none">
                      {{director.recordDate | date : "dd-MM-y"}} </td>
                    <td tabindex="1"> {{director.dividendAmount}} </td>
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfPayment | date : "yMMdd"}}</span>
                      {{director.dateOfPayment | date : "dd-MM-y"}} </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfPayment | date : "dd-MM-y"}} </td>
                    <td tabindex="1"> {{director.intermDividend}} </td>
                    <td tabindex="1"> {{director.finalDividend}} </td>
  
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfDeclaration | date : "yMMdd"}}</span>
                      {{director.dateOfDeclaration | date : "dd-MM-y"}} </td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfDeclaration | date : "dd-MM-y"}} </td>
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" [appHasPermission]="{'Url': '/register/paymentOfDividend/edit?goveva=true&email=', 'method':'put', 'menu': 'paymentOfDividend'}" (click)="editPaymentdetail(director._id)" class="btn-sm btn btn-warning">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" [appHasPermission]="{'Url': '/register/paymentOfDividend/edit?goveva=true&email=', 'method':'put', 'menu': 'paymentOfDividend'}" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete payment of dividend details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletePaymentOfDividenddetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>